"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradingWindowSchema = void 0;
const mystake_common_sdk_1 = require("@boulevard1/mystake-common-sdk");
const date_fns_1 = require("date-fns");
const yup = __importStar(require("yup"));
const constants_1 = require("../constants");
const today = new Date();
today.setHours(0, 0, 0, 0);
const TradingWindowSchema = (maxShares) => yup.object().shape({
    shareClassId: yup.string().required(constants_1.SHARE_CLASS_REQUIRED).typeError(constants_1.SHARE_CLASS_REQUIRED),
    sharesInputType: yup
        .mixed()
        .required("Shares input type is required")
        .oneOf(Object.values(mystake_common_sdk_1.SharesInput), "Please enter input type to set maximum tradable shares"),
    sharesAvailableToTrade: yup.number().when("sharesInputType", {
        is: "percentage",
        then: yup
            .number()
            .required(constants_1.SHARES_AVAILABLE_TO_TRADE_REQUIRED)
            .typeError(constants_1.SHARES_AVAILABLE_TO_TRADE_REQUIRED)
            .max(100, "Shares available to trade must be less than or equal to 100%")
            .min(0.01, "Shares available to trade must be greater than or equal to 0.01%"),
        otherwise: yup
            .number()
            .required(constants_1.SHARES_AVAILABLE_TO_TRADE_REQUIRED)
            .typeError(constants_1.SHARES_AVAILABLE_TO_TRADE_REQUIRED)
            .max(maxShares, "Shares available to trade must be less than or equal to total shares issued")
            .min(1, "Shares available to trade must be greater than or equal to 1"),
    }),
    sellAuctionOpenDate: yup.date().when("windowType", {
        is: mystake_common_sdk_1.WindowType.SELL,
        then: yup
            .date()
            .required(constants_1.OPEN_DATE_REQUIRED)
            .typeError(constants_1.OPEN_DATE_REQUIRED)
            .max((0, date_fns_1.addYears)(new Date(), 1), "Sell auction open date must be less than or equal to 1 year from today")
            .min(today, "Sell auction open date must be greater than or equal to today"),
        otherwise: yup.date().nullable(),
    }),
    sellAuctionOpenTime: yup.date().when("windowType", {
        is: mystake_common_sdk_1.WindowType.SELL,
        then: yup
            .date()
            .required(constants_1.OPEN_TIME_REQUIRED)
            .typeError(constants_1.OPEN_TIME_REQUIRED)
            .min((0, date_fns_1.addMinutes)(new Date(), 5), "Sell auction open time must be at least 5 minutes from now"),
        otherwise: yup.date().nullable(),
    }),
    offerWindow: yup.number().when("windowType", {
        is: mystake_common_sdk_1.WindowType.SELL,
        then: yup
            .number()
            .required("Please enter Offer window")
            .min(5, "Offer window must be greater than or equal to 5 minutes")
            .typeError("Offer window is required"),
        otherwise: yup.number().nullable(),
    }),
    sellAuctionCloseDate: yup
        .date()
        .when(["sellAuctionOpenDate", "offerWindow", "windowType"], (sellAuctionOpenDate, offerWindow, windowType, schema) => windowType === mystake_common_sdk_1.WindowType.SELL
        ? schema
            .test("Sell auction close date", "Sell auction close date must be at least 5 minutes after offer price time", (sellAuctionCloseDate) => (0, date_fns_1.isAfter)(new Date(sellAuctionCloseDate.toDateString()), new Date((0, date_fns_1.addMinutes)(sellAuctionOpenDate, Number(offerWindow) + 5).toDateString())) ||
            (0, date_fns_1.isEqual)(new Date(sellAuctionCloseDate.toDateString()), new Date((0, date_fns_1.addMinutes)(sellAuctionOpenDate, Number(offerWindow) + 5).toDateString())))
            .required(constants_1.CLOSE_DATE_REQUIRED)
            .typeError(constants_1.CLOSE_DATE_REQUIRED)
        : schema.nullable()),
    sellAuctionCloseTime: yup
        .date()
        .when(["sellAuctionOpenDate", "offerWindow", "windowType"], (sellAuctionOpenDate, offerWindow, windowType, schema) => windowType === mystake_common_sdk_1.WindowType.SELL
        ? schema
            .test("Sell auction close time", "Sell auction close time must be at least 5 minutes after offer price time", (sellAuctionCloseTime) => (0, date_fns_1.isAfter)(new Date(sellAuctionCloseTime.toString()), (0, date_fns_1.addMinutes)(sellAuctionOpenDate, Number(offerWindow) + 10)) ||
            (0, date_fns_1.isSameMinute)(new Date(sellAuctionCloseTime.toString()), (0, date_fns_1.addMinutes)(sellAuctionOpenDate, Number(offerWindow) + 10)))
            .required(constants_1.CLOSE_TIME_REQUIRED)
            .typeError(constants_1.CLOSE_TIME_REQUIRED)
        : schema.nullable()),
    tradingOpenDate: yup.date().when("windowType", {
        is: mystake_common_sdk_1.WindowType.SELL,
        then: yup.date().nullable(),
        otherwise: yup.date().required(constants_1.OPEN_DATE_REQUIRED).typeError(constants_1.OPEN_DATE_REQUIRED),
    }),
    tradingOpenTime: yup.date().when("windowType", {
        is: mystake_common_sdk_1.WindowType.SELL,
        then: yup.date().nullable(),
        otherwise: yup.date().required(constants_1.OPEN_TIME_REQUIRED).typeError(constants_1.OPEN_TIME_REQUIRED),
    }),
    tradingCloseDate: yup
        .date()
        .when(["tradingOpenDate", "windowType"], (tradingOpenDate, windowType, schema) => windowType === mystake_common_sdk_1.WindowType.SELL
        ? schema.nullable()
        : schema
            .test("Trading close date", "Trading close date must be at least 5 minutes after open time of the trading window and at most 14 days", (tradingCloseDate) => ((0, date_fns_1.isAfter)(new Date(tradingCloseDate), new Date((0, date_fns_1.addMinutes)(tradingOpenDate, 5).toDateString())) ||
            (0, date_fns_1.isSameDay)(new Date(tradingCloseDate), new Date((0, date_fns_1.addMinutes)(tradingOpenDate, 5).toDateString()))) &&
            ((0, date_fns_1.isBefore)(new Date(tradingCloseDate), new Date((0, date_fns_1.addDays)(tradingOpenDate, 14).toDateString())) ||
                (0, date_fns_1.isSameDay)(new Date(tradingCloseDate), new Date((0, date_fns_1.addDays)(tradingOpenDate, 14).toDateString()))))
            .required(constants_1.CLOSE_DATE_REQUIRED)
            .typeError(constants_1.CLOSE_DATE_REQUIRED)),
    tradingCloseTime: yup
        .date()
        .when(["tradingOpenDate", "windowType"], (tradingOpenDate, windowType, schema) => windowType === mystake_common_sdk_1.WindowType.SELL
        ? schema.nullable()
        : schema
            .test("Trading close time", "Trading close time must be at least 5 minutes after open time of the trading window and at most 14 days", (tradingCloseTime) => ((0, date_fns_1.isAfter)(new Date(tradingCloseTime.toString()), (0, date_fns_1.addMinutes)(tradingOpenDate, 5)) ||
            (0, date_fns_1.isSameMinute)(new Date(tradingCloseTime.toString()), (0, date_fns_1.addMinutes)(tradingOpenDate, 5))) &&
            ((0, date_fns_1.isBefore)(new Date(tradingCloseTime.toString()), (0, date_fns_1.addDays)(tradingOpenDate, 14)) ||
                (0, date_fns_1.isSameMinute)(new Date(tradingCloseTime.toString()), (0, date_fns_1.addDays)(tradingOpenDate, 14))))
            .required(constants_1.CLOSE_TIME_REQUIRED)
            .typeError(constants_1.CLOSE_TIME_REQUIRED)),
    allowCrowdSourcedInvestors: yup.boolean().required(),
    allowEmployeeInvestors: yup.boolean().required(),
    allowRetailInvestors: yup.boolean().required(),
    allowSophisticatedInvestors: yup.boolean().required(),
    windowType: yup.string(),
    windowTradingType: yup.string().nullable(),
    sharePriceType: yup.string(),
    ceilingPrice: yup.number().nullable().typeError("Please enter the ceiling price").positive(constants_1.CEILING_PRICE_POSITIVE),
    floorPrice: yup
        .number()
        .nullable()
        .transform((value) => (Number.isNaN(value) ? null : value))
        .typeError("Please enter the floor price")
        .positive(constants_1.FLOOR_PRICE_POSITIVE)
        .when("ceilingPrice", {
        is: (ceilingPrice) => ceilingPrice !== null,
        then: yup.number().test("floorPrice", constants_1.FLOOR_PRICE_LESS_THAN_CEILING_PRICE, function test(value) {
            return value < this.parent.ceilingPrice;
        }),
    }),
    fixedPrice: yup
        .number()
        .nullable()
        .typeError("Please enter the buy price")
        .min(0.01, "Buy price must be greater than or equal to 0.01"),
});
exports.TradingWindowSchema = TradingWindowSchema;
//# sourceMappingURL=TradingWindowSchema.js.map